// Footer row across the wizard: Back / Save draft / Continue (or Launch on step 5).

import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { SimpleButton, Flex } from '../../../../ui';
import { WIZARD_STEP, WIZARD_TOTAL_STEPS } from '../../constants';

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding-top: 24px;
  margin-top: 24px;
  border-top: 1px solid ${({ theme }) => theme.colors.NEU_100};
  flex-wrap: wrap;

  /* Below phablet: back button on top, action buttons wrap below taking full width. */
  @media (max-width: 560px) {
    flex-direction: column;
    align-items: stretch;

    & > * {
      width: 100%;
    }
  }
`;

const WizardFooter = ({
  step,
  canContinue,
  isSaving,
  isLaunching,
  onBack,
  onSaveDraft,
  onContinue,
  onLaunch,
  onTestSend,
}) => {
  const { t } = useTranslation();
  const isLast = step === WIZARD_STEP.REVIEW;
  const isFirst = step === WIZARD_STEP.BASICS;

  return (
    <Footer>
      <SimpleButton variant='ghost' startIcon='ArrowLeft' onClick={onBack} disabled={isFirst}>
        {t('globals.back', 'Back')}
      </SimpleButton>
      <Flex gap='12'>
        {!isLast && (
          <SimpleButton variant='ghost' onClick={onSaveDraft} isLoading={isSaving}>
            {t('campaigns.saveDraft', 'Save draft')}
          </SimpleButton>
        )}
        {isLast && (
          <SimpleButton variant='ghost' startIcon='Send' onClick={onTestSend}>
            {t('campaigns.sendTest', 'Send test')}
          </SimpleButton>
        )}
        {isLast ? (
          <SimpleButton variant='primary' onClick={onLaunch} isLoading={isLaunching} disabled={!canContinue}>
            {t('campaigns.launch', 'Launch campaign')}
          </SimpleButton>
        ) : (
          <SimpleButton variant='primary' endIcon='ArrowRight' onClick={onContinue} disabled={!canContinue}>
            {t('campaigns.continue', 'Continue')} ({step}/{WIZARD_TOTAL_STEPS})
          </SimpleButton>
        )}
      </Flex>
    </Footer>
  );
};

export default WizardFooter;
